import { Injectable, Injector } from '@angular/core';
import { PersonalizationService } from '@docma-mm-core/personalization/personalization.service';
import { JwtAuthService,AuthService } from '@mydocma/auth';
import { Logger } from '@mydocma/common/src/lib/logger';

export const RECENTLY_USED_POOLS_KEY = 'RecentlyUsedPools';
export const MAX_RECENTLY_USED_POOLS = 5;

@Injectable()
export class RecentlyUsedPoolsService {

    private _personalizationService: PersonalizationService;
    private get personalizationService(): PersonalizationService {
        if (!this._personalizationService) {
            this._personalizationService = this.injector.get(PersonalizationService);
        }
        return this._personalizationService;
    }

    private readonly jwtAuthService: JwtAuthService

    constructor(private readonly injector: Injector, private readonly authService: AuthService, private readonly logger: Logger) { 
        this.jwtAuthService = authService as any;
    }

    async addRecentlyUsedPool(poolId: number): Promise<void> {
         const schemaId = this.jwtAuthService.getAccessTokenClaims().db_id;
        if (!schemaId) {
            this.logger.error('[RecentlyUsedPoolsService] No schemaId found', '', 'RecentlyUsedPoolsService');
            return;
        }
        let recentlyUsedIds: number[] = await this.getRecentlyUsedPoolIds(schemaId) || [];

        recentlyUsedIds = recentlyUsedIds.filter(id => id !== poolId);

        recentlyUsedIds.push(poolId);

        if (recentlyUsedIds.length > MAX_RECENTLY_USED_POOLS) {
            recentlyUsedIds.shift();
        }

        await this.personalizationService.setValue(this.getDbKey(schemaId), recentlyUsedIds);
    }

    async getRecentlyUsedPoolIds(schemaId: string): Promise<number[]> {
        return this.personalizationService.getValue(this.getDbKey(schemaId));
    }

    private getDbKey(schemaId: string): string {
        return `${schemaId}.${RECENTLY_USED_POOLS_KEY}`;
    }
} 